<template>
<div @click="navigate($event)" class="px-4 cursor-pointer">
    <div class="rounded overflow-hidden shadow-lg w-full">
        <img v-if="course.course_image.length > 5" class="w-full h-48 object-cover" :src="course.course_image" alt="Sunset in the mountains" />
        <img v-else class="w-full h-48 object-cover" src="https://res.cloudinary.com/dldd8ucby/image/upload/v1541714614/ra_logo.png" alt="Sunset in the mountains" />
        <div class="px-6 py-4">
            <div class="program-main mb-2 tenant-main-color">
                {{ course.title }}
            </div>
            <p class="program-content text-gray-700 text-base">
                {{ course.caption }}
                <br/>( {{ course.program }} )<br/>
            </p>
            <div class=" program-content flex tenant-main-color justify-between">
                <span>
                </span>
                <div>
                    <span id="edit" class="ml-8">Edit</span> |
                    <span id="settings">Settings</span> |
                    <span id="delete">Delete</span>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    mapActions
} from "vuex";
export default {
    props: ["course"],
    methods: {
        ...mapActions(["deleteTenantCourse"]),
        popConfirm() {
            this.$confirm({
                message: `Are you sure you want to delete this course?`,
                button: {
                    no: "No",
                    yes: "Yes",
                },

                callback: (confirm) => {
                    if (confirm) {
                        this.delete();
                    }
                },
            });
        },
        async delete() {
            let res = await this.deleteTenantCourse({
                id: this.course.id,
            });
            if (res.status === 200 || res.status === 201) {
                this.$Bus.$emit("notify", {
                    type: "success",
                    message: "Course deleted successfully",
                });
                this.$Bus.$emit("fetch-courses", {});
                location.reload();
            } else {
                this.$Bus.$emit("notify", {
                    type: "error",
                    message: res.data.errors ?
                        res.data.errors[0].title : "An error occured",
                });
            }

        },
        navigate(e) {
            e.stopImmediatePropagation();
            if (e.target.id == "edit") {
                this.$router.push({
                    name: "tenant-edit-course",
                    params: {
                        id: this.course.id
                    },
                });
            } else if (e.target.id === "delete") {
                this.popConfirm();
            } else if (e.target.id === "settings") {
                this.$router.push({
                    name: "tenant-course-reminder",
                    params: {
                        id: this.course.id
                    },
                });
            } else {
                this.$router.push({
                    name: "tenant-single-course",
                    params: {
                        id: this.course.id
                    },
                });
            }
        },
    },
};
</script>

<style lang="css" scoped>
.program-main {
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
}

.program-content {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 18px;
}
</style>
